<div class="error_page">
  <div class="error_page_name">Whoops!</div>
  <img src="/assets/img/404-error.png" alt="" class="error_page_img">
  <div class="error_page_title">Sorry!</div>
  <div class="error_page_text">Sorry, we have encountered some issues while opening the task and are already working on fixing it. Please, refresh the webpage.</div>
</div>
<div id="roadmap-paint-finished"></div>
